import api from './api';

export const authService = {
  login: async (username, password) => {
    const response = await api.post('/auth/login', { username, password });
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  },

  getCurrentUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  }
};

export const clubService = {
  getClubs: () => api.get('/clubs').then(res => res.data),
  getClub: (id) => api.get(`/clubs/${id}`).then(res => res.data),
  getClubSummary: (id) => api.get(`/clubs/${id}/summary`).then(res => res.data),
  createClub: (data) => api.post('/clubs', data).then(res => res.data),
  updateClub: (id, data) => api.put(`/clubs/${id}`, data).then(res => res.data),
  deleteClub: (id) => api.delete(`/clubs/${id}`).then(res => res.data)
};

export const aircraftService = {
  getAircraft: (clubId) => api.get(`/clubs/${clubId}/aircraft`).then(res => res.data),
  getAircraftById: (clubId, id) => api.get(`/clubs/${clubId}/aircraft/${id}`).then(res => res.data),
  createAircraft: (clubId, data) => api.post(`/clubs/${clubId}/aircraft`, data).then(res => res.data),
  updateAircraft: (clubId, id, data) => api.put(`/clubs/${clubId}/aircraft/${id}`, data).then(res => res.data),
  deleteAircraft: (clubId, id) => api.delete(`/clubs/${clubId}/aircraft/${id}`).then(res => res.data)
};

export const imageService = {
  getImages: (clubId, type) => {
    const params = type ? { type } : {};
    return api.get(`/clubs/${clubId}/images`, { params }).then(res => res.data);
  },
  uploadImage: (clubId, formData) => {
    return api.post(`/clubs/${clubId}/images`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => res.data);
  },
  uploadBatch: (clubId, formData) => {
    return api.post(`/clubs/${clubId}/images/batch`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(res => res.data);
  },
  updateImage: (clubId, id, data) => api.put(`/clubs/${clubId}/images/${id}`, data).then(res => res.data),
  deleteImage: (clubId, id) => api.delete(`/clubs/${clubId}/images/${id}`).then(res => res.data),
  removeDuplicates: (clubId, type) => {
    const params = type ? { type } : {};
    return api.post(`/clubs/${clubId}/images/remove-duplicates`, null, { params }).then(res => res.data);
  },
  reorderImages: (clubId, imageIds) => api.put(`/clubs/${clubId}/images/reorder`, { imageIds }).then(res => res.data)
};

export const tvService = {
  getTVs: (clubId) => api.get(`/clubs/${clubId}/tvs`).then(res => res.data),
  getTV: (clubId, id) => api.get(`/clubs/${clubId}/tvs/${id}`).then(res => res.data),
  createTV: (clubId, data) => api.post(`/clubs/${clubId}/tvs`, data).then(res => res.data),
  updateTV: (clubId, id, data) => api.put(`/clubs/${clubId}/tvs/${id}`, data).then(res => res.data),
  deleteTV: (clubId, id) => api.delete(`/clubs/${clubId}/tvs/${id}`).then(res => res.data),
  getTVAircraft: (clubId, id) => api.get(`/clubs/${clubId}/tvs/${id}/aircraft`).then(res => res.data),
  updateTVAircraft: (clubId, id, aircraftIds) => api.put(`/clubs/${clubId}/tvs/${id}/aircraft`, { aircraftIds }).then(res => res.data),
  autoGenerateSequence: (clubId, tvId, options = {}) => api.post(`/clubs/${clubId}/tvs/${tvId}/auto-sequence`, options).then(res => res.data)
};

export const sequenceService = {
  getSequences: (clubId, tvId) => api.get(`/clubs/${clubId}/tvs/${tvId}/sequences`).then(res => res.data),
  getSequence: (clubId, tvId, id) => api.get(`/clubs/${clubId}/tvs/${tvId}/sequences/${id}`).then(res => res.data),
  createSequence: (clubId, tvId, data) => api.post(`/clubs/${clubId}/tvs/${tvId}/sequences`, data).then(res => res.data),
  updateSequence: (clubId, tvId, id, data) => api.put(`/clubs/${clubId}/tvs/${tvId}/sequences/${id}`, data).then(res => res.data),
  deleteSequence: (clubId, tvId, id) => api.delete(`/clubs/${clubId}/tvs/${tvId}/sequences/${id}`).then(res => res.data),
  clearAllSequences: (clubId, tvId) => api.delete(`/clubs/${clubId}/tvs/${tvId}/sequences`).then(res => res.data),
  reorderSequences: (clubId, tvId, sequenceIds) => api.put(`/clubs/${clubId}/tvs/${tvId}/sequences/reorder`, { sequenceIds }).then(res => res.data)
};

export const airportService = {
  getAirports: () => api.get('/airports').then(res => res.data),
  getAirport: (id) => api.get(`/airports/${id}`).then(res => res.data),
  createAirport: (data) => api.post('/airports', data).then(res => res.data),
  updateAirport: (id, data) => api.put(`/airports/${id}`, data).then(res => res.data),
  deleteAirport: (id) => api.delete(`/airports/${id}`).then(res => res.data)
};

export const calendarService = {
  getEvents: (clubId) => api.get(`/clubs/${clubId}/events`).then(res => res.data),
  getEvent: (clubId, id) => api.get(`/clubs/${clubId}/events/${id}`).then(res => res.data),
  createEvent: (clubId, data) => api.post(`/clubs/${clubId}/events`, data).then(res => res.data),
  updateEvent: (clubId, id, data) => api.put(`/clubs/${clubId}/events/${id}`, data).then(res => res.data),
  deleteEvent: (clubId, id) => api.delete(`/clubs/${clubId}/events/${id}`).then(res => res.data)
};

export const webSourcesService = {
  getWebSources: (clubId) => api.get(`/clubs/${clubId}/web-sources`).then(res => res.data),
  getWebSource: (clubId, id) => api.get(`/clubs/${clubId}/web-sources/${id}`).then(res => res.data),
  createWebSource: (clubId, data) => api.post(`/clubs/${clubId}/web-sources`, data).then(res => res.data),
  updateWebSource: (clubId, id, data) => api.put(`/clubs/${clubId}/web-sources/${id}`, data).then(res => res.data),
  deleteWebSource: (clubId, id) => api.delete(`/clubs/${clubId}/web-sources/${id}`).then(res => res.data)
};

export const statsService = {
  getStatsExport: (clubId, from, to) =>
    api.get(`/clubs/${clubId}/stats/export`, { params: { from, to }, responseType: 'blob' }).then(res => res),
  getStatsDebug: (clubId) => api.get(`/clubs/${clubId}/stats/debug`).then(res => res.data)
};


